import React from 'react';
import PropTypes from 'prop-types';
import SafeHTML from './SafeHTML';
import style from '../../scss/components/ButtonLink.scss';


export default class ButtonLink extends React.Component {

  static propTypes = {
    openInNewWindow: PropTypes.bool,
    text: PropTypes.string,
    url: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    openInNewWindow: false,
  }

  handleOnClick = (e) => {

    if (this.props.onClick) {
      this.props.onClick(e);
    }

  }

  render() {
    return (
      <a
        className={`ButtonLink ${this.props.className}`}
        href={this.props.url}
        onClick={this.handleOnClick}
        target={this.props.openInNewWindow ? '_blank' : ''}>
        <span className='hero-grid-button'>{this.props.text}</span>
        {this.props.icon && <i className={this.props.icon}></i>}
      </a>
    )
  }

}
